/**
 * jQuery plugin called addNotes that opens a modal using foundationPopup (which exists in foundationPopup.js)  when you click the element
 * this plugin is called on.
 *
 * If initialized, using the elm will also have a .setNotes() method that will allow you to set the notes
 */
(function($){
    $.fn.addNotes = function(options){
        // if there's a textarea next to it, get the value of that
        // on change of tinymce, get the contents and set it into that textarea
        // if there's no textarea yet, create it, and make sure it's hidden right away


        return this.each(function(){
            let textarea = $(this).next("textarea");
            const $this = $(this);
            const filledString = $this.data('filled');
            const emptyString = $this.data('empty');

            const settings = $.extend({
                title: "Opmerking",
                notes: textarea.html(),
                callback: function(){}
            }, options);

            $this.on("click", function(){
                settings.notes = textarea.html();

                if (!textarea.length) {
                    textarea = $("<textarea style='display: none;'></textarea>");
                    $(this).after(textarea);
                }


                const $form = $("<form></form>");
                const $title = $("<h2>" + settings.title + "</h2>");
                const $textarea = $("<textarea></textarea>");
                const $button = $("<button class='button'>Opslaan</button>");

                $form.append($title);
                $form.append($textarea);
                $form.append($button);

                foundationPopup($form,(elm, popup) => {
                    window.requestAnimationFrame(() => {
                        $textarea.customTextarea(undefined, {
                            toolbar1: 'bold italic underline',
                            toolbar2: '',
                            toolbar3: '',
                        });
                    });
                    $textarea.html(settings.notes);

                    $button.on("click", function(){
                        textarea.html($textarea.val());
                        textarea.trigger("change");

                        if ($textarea.val().length) {
                            $this.html(filledString);
                        } else {
                            $this.html(emptyString);
                        }

                        popup.close();
                        setTimeout(() => {
                            elm.parent().remove();
                        }, 500);
                        return false;
                    });
                }, 'small');


                return false;
            });

            $this.setNotes = function(notes){
                settings.notes = notes;
                textarea.html(notes);
            };
        });
    };
}(jQuery));

